module.exports = __webpack_public_path__ + "static/media/blender-phone.0ec66059.svg";